import React, { useEffect} from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { getPastDate, holdinglistList } from "./action/api-services";
import { setDeliveryDataReducer} from "./redux/slice/deliveryData";
// import TodayTrandingStocks from "./pages/todayTrandingStocks";
// import IncreaseOI from "./pages/IncreaseOI";

import moment from "moment";
// import ChartinkList from "./pages/chartink";
import Footer from "./component/footer";
// import Header from "./component/header";
import BulkDealsPage from "./pages/bulkDeals";
import SpikesPage from "./pages/spikesPage";
import AllSymbolsPage from "./pages/allSymbols";
import PlanetTransitPage from "./pages/planetTransit";
import WatchListPage from "./pages/watchListPage";
import PortfolioListPage from "./pages/portflioListPage";
import LoginPage from "./pages/loginPage";
import { setpastDateReducer } from "./redux/slice/pastDate";
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setHoldingListReducer } from "./redux/slice/holdingList";
import DeliveryHeatMap from "./pages/deliveryHeatMap";
// import PreMarketPage from "./pages/preMarketPage";
import OpenMarketPage from "./pages/openMarketPage";
import HotStarSymbolsPage from "./pages/hotStarSymbols";
import { clearUserTokenReducer } from "./redux/slice/userToken";
import GloldenCrossOverPage from "./pages/goldenCrossOver";
import Nr7BreakoutPage from "./pages/nr7BreakList";
import GoldenStocksPage from "./pages/godenStocks";
import GoldenStocksPage2 from "./pages/godenStocks2";
import OrdersListPage from "./pages/ordersList";
import SmartMoneyPage from "./pages/smartMoneyPage";
import DeliveryPage from "./pages/deliveryPage";
import TrendsSetupPage from "./pages/trendsSetupPage";
import SectorRotationPage from "./pages/sectorRotationPage";
import NewOrderPage from "./pages/newOrderPage";


function App() {
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.userToken.value);
  
  
  const getNextExpiry = () => {
  const now = moment();

  const morning = moment().hour(9).minute(5).second(0).millisecond(0);
  const night = moment().hour(21).minute(5).second(0).millisecond(0);

  let expiry;

  if (now.isBefore(morning)) {
    // Before 9:05 AM → expire at 9:05 AM today
    expiry = morning;
  } else if (now.isBefore(night)) {
    // Between 9:05 AM and 9:05 PM → expire at 9:05 PM today
    expiry = night;
  } else {
    // After 9:05 PM → expire at 9:05 AM tomorrow
    expiry = morning.add(1, "day");
  }

  return expiry.valueOf(); // timestamp (ms)
};



  /* =========================
     1️⃣ TOKEN EXPIRY CHECK
     ========================= */
  useEffect(() => {
    

    const interval = setInterval(() => {
      const expiry = sessionStorage.getItem("token_expiry");
      if (!expiry || Date.now() > Number(expiry)) {
        console.log(">>>>>>>>>>>>> expired", expiry, Date.now(), expiry)
        sessionStorage.clear();
        localStorage.clear();
        localStorage.removeItem('persist:root');
        dispatch(clearUserTokenReducer());
      }
    }, 60000); // every 1 minute

    return () => clearInterval(interval);
  }, []);

  /* =========================
     2️⃣ PAST DATE (ONCE / DAY)
     ========================= */
  useEffect(() => {
    if (!userToken) return;
    getPastDate(userToken)
      .then((res) => {
        // console.log("res", res);
        if (res?.status === 401 || res?.data.message === "Token expired" || res?.data.code === "invalid_token") {
            sessionStorage.clear();
            localStorage.clear();
            localStorage.removeItem('persist:root');
            dispatch(clearUserTokenReducer());
        }else{
          dispatch(setpastDateReducer(res.data.data || []));
        }
      })
      .catch(console.error);
  }, [userToken, dispatch]);

  /* =========================
     3️⃣ HOLDINGS (ON LOGIN)
     ========================= */
  useEffect(() => {
    if (!userToken) return;
    holdinglistList(userToken)
      .then((res) => {
          dispatch(setHoldingListReducer(res.data.data || []));      
      })
      .catch(console.error);

  }, [userToken, dispatch]);

// console.log("userToken", userToken)
  return (
    <React.Fragment>
        <Router>
              {/* {window.location.pathname !== '/login'? <Header />:null} */}
              {/* <div className="pageContainer"> */}
              <Routes>
                    {/* <Route path={`/`} element={<ChartinkList />} /> */}
                    {userToken!==null && userToken!=='' ? <Route path={`/`} element={<TrendsSetupPage />} />: <Route path={`/`} element={<LoginPage />} />}
                    <Route path={`/delivery`} element={<DeliveryPage />} />
                    {/* <Route path={`/`} element={<LoginPage />} /> */}
                    {/* <Route path={`/todaynse`} element={<TodayTrandingStocks />} /> */}
                    {/* <Route path={`/oi`} element={<IncreaseOI />} /> */}
                    {/* <Route path={`/delivery`} element={<DeliveryPage />} /> */}
                    {/* <Route path={`/pre-market`} element={<PreMarketPage />} /> */}
                    {/* <Route path={`/today-market`} element={<OpenMarketPage />} /> */}
                    <Route path={`/rotation`} element={<SectorRotationPage />} />
                    <Route path={`/orders`} element={<OrdersListPage />} />
                    <Route path={`/bulk`} element={<BulkDealsPage />} />
                    <Route path={`/spikes`} element={<SpikesPage />} />
                    <Route path={`/golden-crossover`} element={<GloldenCrossOverPage />} />     
                    <Route path={`/nr7-breakout`} element={<Nr7BreakoutPage />} />     
                    <Route path={`/golden-stocks`} element={<GoldenStocksPage />} />     
                    <Route path={`/golden-stocks2`} element={<GoldenStocksPage2 />} />     
                    
                    <Route path={`/symbols`} element={<AllSymbolsPage />} />
                    <Route path={`/hot-stars`} element={<HotStarSymbolsPage />} />
                    {/* <Route path={`/hot-stars`} element={<HostStartsListPage />} />                */}
                    <Route path={`/watchlist`} element={<WatchListPage />} />
                    <Route path={`/pf`} element={<PortfolioListPage />} />
                    <Route path={`/transit`} element={<PlanetTransitPage />} />      
                    <Route path={`/delivery-heatmap`} element={<DeliveryHeatMap />} />
                    <Route path={`/trends-setup`} element={<TrendsSetupPage />} />

                    <Route path={`/new-order`} element={<NewOrderPage />} />

                    

                    <Route path={`/sm`} element={<SmartMoneyPage />} />
              </Routes>
              {/* </div> */}
              {userToken!==null && userToken!=='' ? <Footer />:null}
        </Router>
        <ToastContainer position="top-right" autoClose={3000} />
    </React.Fragment>
  );
}

export default App;